import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
const KEY = "kingsley_bag_v1";

const lineKey = (it) => `${it.product_id}|${JSON.stringify(it.options)}|${it.details || ""}`;

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = (item) => {
    setItems((cur) => {
      const k = lineKey(item);
      const found = cur.find((c) => lineKey(c) === k);
      if (found) return cur.map((c) => (lineKey(c) === k ? { ...c, qty: Math.min(20, c.qty + item.qty) } : c));
      return [...cur, { ...item, key: `${Date.now()}-${Math.random().toString(36).slice(2, 6)}` }];
    });
    setOpen(true);
  };
  const setQty = (key, qty) => setItems((cur) => cur.map((c) => (c.key === key ? { ...c, qty: Math.max(1, Math.min(20, qty)) } : c)));
  const remove = (key) => setItems((cur) => cur.filter((c) => c.key !== key));
  const clear = () => setItems([]);
  const count = items.reduce((n, i) => n + i.qty, 0);
  const subtotal = items.reduce((n, i) => n + i.price * i.qty, 0);

  return (
    <CartCtx.Provider value={{ items, add, setQty, remove, clear, count, subtotal, open, setOpen }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
